var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "Hotel",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "Hotel",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48 1.15a.07.07 0 00-.04-.13L8.5.86 8.07.04a.08.08 0 00-.14 0L7.5.86l-.93.16a.07.07 0 00-.04.13l.66.66-.14.92c0 .06.06.1.11.07L8 2.4l.85.4c.05.03.11-.01.1-.07l-.13-.92.66-.66zm-4 1a.07.07 0 00-.04-.13l-.93-.16-.44-.82a.08.08 0 00-.14 0l-.44.82-.93.16a.07.07 0 00-.04.13l.66.66-.14.92c0 .06.06.1.11.07L4 3.4l.85.4c.05.03.11-.01.1-.07l-.13-.92.66-.66zm7.96-.13c.06 0 .08.08.04.13l-.66.66.14.92c0 .06-.06.1-.11.07L12 3.4l-.85.4a.08.08 0 01-.1-.07l.13-.92-.66-.66a.07.07 0 01.04-.13l.93-.16.44-.82c.03-.05.1-.05.14 0l.44.82.93.16zM7 8a1 1 0 100 2h2a1 1 0 000-2H7z",
    shapeRendering: "geometricPrecision"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 16a1 1 0 001-1V9a1 1 0 00-1-1h-2V6a1 1 0 00-1-1H4a1 1 0 00-1 1v4H1a1 1 0 00-1 1v4a1 1 0 001 1h14zM5 7v7h2v-1a1 1 0 112 0v1h2V7H5zm9 7h-1v-4h1v4zM3 14v-2H2v2h1z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgHotelsIcon;